import React from 'react';
import { Button } from '@insurancemenu/imenu-components-lib/dist/components';
import { Done } from '@insurancemenu/imenu-components-lib/dist/icons';
import { RateSegment } from '@insurancemenu/imenu-components-lib/dist/types/productCardsTypings';
import colors from '@insurancemenu/imenu-components-lib/dist/utils/colors';
import uniqid from 'uniqid';
import { RATE_SEGMENT_INFO } from 'global/utils/RateSegmentHelper';
import { createStyles } from './styles';

export interface RateSegmentCardProps {
  rateSegment: RateSegment;
  descriptionList: string[];
  onContinue: () => void;
}

const RateSegmentCard = ({ rateSegment, descriptionList, onContinue }: RateSegmentCardProps): JSX.Element => {
  const classes = createStyles();
  return (
    <li className={classes.cardWrapper}>
      <div className={classes.cardHeader}>
        {RATE_SEGMENT_INFO[rateSegment].icon}
        <h3 className={classes.cardTitle}>{RATE_SEGMENT_INFO[rateSegment].label}</h3>
      </div>
      <ul className={classes.descriptionList}>
        {descriptionList.map((description) => (
          <li key={uniqid()} className={classes.descriptionItem}>
            <Done color={colors.blue[600]} height="2.4rem" width="2.4rem" />
            {description}
          </li>
        ))}
      </ul>
      <Button color="primary" className={classes.continueButton} size="large" onClick={onContinue}>
        Continue
      </Button>
    </li>
  );
};

export default RateSegmentCard;
